// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type ConversationsCloseResponse = SlackAPIResponse & {
  already_closed?: boolean;
  error?: string;
  needed?: string;
  no_op?: boolean;
  ok: boolean;
  provided?: string;
};
